import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'eventq-lined-tab',
  templateUrl: './lined-tab.html',
  styleUrl: './lined-tab.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqLinedTab {
  readonly label = input.required<string>();
  readonly count = input(0);
  readonly showCount = input(true);
  readonly active = input(true);

  readonly selected = output<void>();
}
